module.exports = __webpack_public_path__ + "img/bind-dd-bg.6a8c6688.png";